<template>
  <main
    class="text-center relative z-20 py-6 md:pt-0 md:flex md:justify-center md:items-center"
    id="contact"
  >
    <Teleport to="body">
      <NoticeView v-if="open" @close="open = false" />
    </Teleport>
    <Teleport to="body">
      <div
        v-if="send"
        class="fixed w-full h-full inset-0 bg-black/80 flex justify-center items-center"
        style="z-index: 99999"
      >
        <div
          class="bg-white w-full max-w-xl m-8 rounded p-8 shadow-lg font-neue text-lg"
        >
          <h1 class="adlam text-[5vw] md:text-3xl w-full text-center mb-4">
            Email envoyé !
          </h1>
          <p class="text-center leading-4">
            Un email contenant un lien vous permettant de participer plus tard
            vient de vous être envoyé à {{ form.email }}.
          </p>
          <p class="text-center">
            <router-link to="/"
              ><span class="button block m-auto mt-6">Fermer</span></router-link
            >
          </p>
        </div>
      </div>
    </Teleport>

    <div class="relative z-40 max-w-5xl">
      <h1
        class="text-[5vw] leading-[6vw] md:leading-normal md:text-3xl adlam mb-6 mt-8 uppercase"
      >
        Vous n’avez pas encore acheté<br />deux produits participants ?*
      </h1>

      <p
        class="text-[4vw] leading-[5vw] sm:text-xl uppercase mb-6 sm:font-bold"
      >
        Ne vous inquiétez pas, en remplissant <br class="md:hidden" />le
        <br class="hidden md:block" />formulaire ci-dessous vous<br
          class="md:hidden"
        />
        recevrez un email<br class="hidden md:block" />pour compléter<br
          class="md:hidden"
        />
        votre inscription et télécharger <br />votre ticket de caisse
        ultérieurement.
      </p>
      <form class="px-[10vw] sm:px-8">
        <!-- <div v-if="!code" class="form-item">
          <input
            @input="error.code = ''"
            :disabled="loadingState"
            required
            v-model="form.code"
            type="text"
            placeholder="Veuillez indiquer le code unique**"
          />
          <span v-if="error.code" class="error">**{{ error.code }}</span>
        </div> -->
        <div class="form-item">
          <input
            @input="error.email = ''"
            :disabled="loadingState"
            required
            v-model="form.email"
            class="w-full"
            id="email"
            type="email"
            placeholder="Email**"
          />
          <span v-if="error.email" class="error">**{{ error.email }}</span>
        </div>
        <div class="form-item">
          <input
            @input="error.lastname = ''"
            :disabled="loadingState"
            required
            v-model="form.lastname"
            id="lastname"
            type="text"
            placeholder="Nom**"
          />
          <span v-if="error.lastname" class="error"
            >**{{ error.lastname }}</span
          >
        </div>
        <div class="form-item">
          <input
            @input="error.firstname = ''"
            :disabled="loadingState"
            required
            v-model="form.firstname"
            id="firstname"
            type="text"
            placeholder="Prénom**"
          />
          <span v-if="error.firstname" class="error"
            >**{{ error.firstname }}</span
          >
        </div>
      </form>
      <div
        class="text-sm text-justify mt-12 flex justify-center md:justify-start items-baseline max-w-[74%] sm:max-w-[450px] mx-auto"
      >
        <input
          type="checkbox"
          name="confirm"
          v-model="form.valid"
          class="mr-1"
          id="confirm"
        /><label
          class="cursor-pointer text-[14px] md:text-sm text-justify"
          for="confirm"
          >J’accepte le traitement de mes données personnelles uniquement dans
          le cadre de la gestion du jeu, conformément à la
          <a
            href="https://oxoformdocs.fra1.digitaloceanspaces.com/6798e2e9cf8bf754eed63dad/politique.pdf"
            target="_blank"
            class="underline font-bold"
            >politique de confidentialité.</a
          >**</label
        >
      </div>
      <div>
        <span v-if="error.valid" class="error block w-full"
          >**{{ error.valid }}</span
        >
      </div>
      <p
        class="!font-neue text-[14px] md:text-sm my-8 w-full max-w-lg px-16 sm:px-10 mx-auto text-justify"
      >
        Ferrero France commerciale traite les données recueillies sur la base de
        votre consentement pour gérer votre participation à ce jeu. Pour en
        savoir plus sur la gestion de vos données personnelles et pour exercer
        vos droits, reportez-vous à la
        <a @click="open = true" class="underline cursor-pointer font-bold"
          >notice ci-jointe</a
        >.
      </p>
      <div class="w-full text-center pt-6">
        <p>
          <a @click.prevent="getResult" class="button uppercase"
            >valider ma préinscription</a
          >
        </p>
      </div>
      <p
        class="!font-neue text-sm italic w-full max-w-3xl mx-auto px-[12vw] my-8 sm:px-4 text-center"
      >
        *Voir
        <a
          href="https://oxoformdocs.fra1.digitaloceanspaces.com/6798e2e9cf8bf754eed63dad/reglement.pdf"
          class="underline font-bold"
          target="_blank"
          >le règlement</a
        ><br />
        **Champs obligatoires
      </p>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import Teleport from "vue2-teleport";
import NoticeView from "@/components/NoticeView.vue";
export default {
  data: function () {
    return {
      code: undefined,
      open: false,
      send: false,
      error: {},
      loadingState: false,
      required_field: ["lastname", "firstname", "email"],
      operationId: "6798e1b0cf8bf754eed61ce3",
      idgame: "2025-Agence TMS-292",
      subid: "",
      uid: "",
      done: false,
      form: {
        operation: undefined,
        addr: {},
      },
    };
  },
  components: {
    Teleport,
    NoticeView,
  },
  async mounted() {
    try {
      console.log(window.code);
      if (window.code) {
        this.code = window.code;
      }

      this.operationId = "6798e1b0cf8bf754eed61ce3";
      this.idgame = "2025-Agence TMS-292";
      this.scrollToTop();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    isRequired(value) {
      return value ? true : "Ce champ est requis";
    },
    async getResult() {
      try {
        this.loadingState = true;
        let error = 0;

        // if (this.code) {
        //   this.form.code = this.code;
        // }

        // if (!this.form.code) {
        //   this.error.code = "Ce champ est requis";
        //   error++;
        //  }

        // const liste = await axios.get(
        //   `https://api-gabarit.promo.dev/api/operations-custom/ferreropalette/data-list/${this.form.code}`
        // );
        //if (!liste.data.already) {
        //   this.error.code = "Code incorrect";
        //   error++;
        //  }

        console.log(error);

        if (!this.form.valid) {
          this.error.valid =
            "Vous devez accepter le traitement de vos données personnelles";
          error++;
        }

        for (let key of this.required_field) {
          if (!this.form[key] || this.form[key] == "") {
            this.error[key] = "Ce champ est requis";
            error++;
          }
        }
        if (error > 0) {
          this.loadingState = false;
          return;
        }

        let id = sessionStorage.getItem("_id");

        if (id == null) id = "n/a";

        // const cd = window.code || this.form.code || "";

        if (error === 0) {
          const formDatas = {
            email: this.form.email,
            //  code_unique: cd,
            last_name: this.form.lastname,
            first_name: this.form.firstname,
          };

          await axios.post(
            `https://api-gabarit.promo.dev/api/operations-custom/ferrerobiscuits/sendLater`,
            formDatas
          );

          this.send = true;
        } else {
          this.loadingState = false;
        }
      } catch (e) {
        console.log(e);
        this.loadingState = false;
      }
    },
  },
};
</script>
<style scoped>
.error {
  color: red !important;
}
</style>
